import util from '../util'

let controller = 'QueueRetorno'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'put', 'persist']), {
  ComboCodigosMensagem: function () {
    return util.Axios.Get(controller + '/ComboCodigosMensagem')
  },
  GetAll (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  }
})
